import React, {useState} from 'react';
import {allOffObject} from "../../function";

const useSortArray = ({
                          initSort,
                          initSortList,
                      }) => {
    const [sort, setSort] = useState(initSort);
    const [sortList, setStateList] = useState(() => {
        const allOff = allOffObject({...initSortList});
        if(initSort?.[0]) {
            allOff[initSort[0].value].sortType = initSort[0].sortType;
        }
        return allOff
    });

    const onClickSort = (data, extra) => {
        if (typeof data === 'object') {
            const copyData = {...data};
            const copySortData = {...sortList};
            if (copyData) {
                if (copySortData[copyData.value]) {
                    const allOff = allOffObject(copySortData);
                    copyData.sortType = !copyData.sortType;
                    allOff[copyData.value].sortType = copyData.sortType;
                    if (extra) {
                        setSort([{...copyData}, ...extra]);
                    } else {
                        setSort([{...copyData}]);
                    }
                    setStateList(copySortData);
                }
            }
        }
    }


    return {sort, sortList, onClickSort}
};

export default useSortArray;
